import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomControl from '../../../../../../components/global/CustomControl';
import { capitalize } from '../../../../../../util/text';
import { formatPriceForDisplay } from '../../../../../../util/format-money';

const propTypes = {
  className: PropTypes.string,
  searchSubscriptionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      days: PropTypes.number.isRequired,
      price: PropTypes.shape({
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  ).isRequired,
  selectedSearchSubscriptionItemId: PropTypes.string,
  onSearchSubscriptionItemSelect: PropTypes.func.isRequired,
};

const RegistrationPaymentDurationSelect = ({
  className,
  searchSubscriptionItems,
  selectedSearchSubscriptionItemId,
  onSearchSubscriptionItemSelect,
}) => {
  const classes = classNames({
    [className]: !!className,
    'view-register-plan-selection-radio': true,
  });

  // Monthly first
  const sortedSubscriptionItems = [...searchSubscriptionItems].sort((a, b) => {
    // Monthly first
    if (a.days < b.days) {
      return -1;
    }

    if (a.days > b.days) {
      return 1;
    }

    return 0;
  });

  // Preselect the monthly sub
  useEffect(() => {
    if (!searchSubscriptionItems?.length) {
      return;
    }

    const monthly = searchSubscriptionItems.find(
      item => item.billing_period === 'MONTHLY',
    );

    if (!!monthly && !selectedSearchSubscriptionItemId) {
      onSearchSubscriptionItemSelect(monthly.id);
    }
  }, [searchSubscriptionItems]);

  return (
    <div className={classes}>
      <h3 className="text-center mb-2">Select Your Plan</h3>

      <div className="view-register-plan-selection-radio d-flex justify-content-center">
        {sortedSubscriptionItems.map(searchSubscriptionItem => {
          return (
            <CustomControl
              required
              key={searchSubscriptionItem.id}
              id={searchSubscriptionItem.id}
              type="radio"
              name="search_subscription_item"
              onChange={() =>
                onSearchSubscriptionItemSelect(searchSubscriptionItem.id)
              }
              checked={
                searchSubscriptionItem.id === selectedSearchSubscriptionItemId
              }
              label={
                <>
                  {capitalize(searchSubscriptionItem.billing_period)} &ndash; $
                  {formatPriceForDisplay(searchSubscriptionItem.price.value)}{' '}
                  <br />
                  {searchSubscriptionItem.trial_days > 0 && (
                    <span className="text-xs">
                      Free for first {searchSubscriptionItem.trial_days} days
                    </span>
                  )}
                </>
              }
            />
          );
        })}
      </div>
    </div>
  );
};

RegistrationPaymentDurationSelect.propTypes = propTypes;

export default RegistrationPaymentDurationSelect;
